const toggleSubmenu = (ev, toggle) => {
  const parentItem = ev.target.closest('.menu__item');
  parentItem.classList.toggle('is-open-submenu', toggle);
  ev.target.closest('.menu__step-body').classList.toggle('show-line', toggle);
  ev.preventDefault();
};
// Open sub menu
attachEvent('.menu__item.has-sub.level-1:not(.is-open-submenu) > .menu__link', 'click', () => {
  const activeSubmenu = document.querySelectorAll('.menu__item.is-open-submenu');
  const activeLine = document.querySelectorAll('.menu__step-body.show-line');
  activeSubmenu.forEach((ele) => ele.classList.remove('is-open-submenu'));
  activeLine.forEach((ele) => ele.classList.remove('show-line'));
});

attachEvent('.menu__item.has-sub > .menu__link', 'click', (ev) => {
  toggleSubmenu(ev, true);
});

// Close submenu - Mobile
attachEvent('.menu__back-btn', 'click', (ev) => {
  toggleSubmenu(ev, false);
});
